/* sugar:assets/text-block.js@2.0.0 */
(function () {
  // A Text block with a [tier] token loads this file itself, and the layout may load it too.
  if (window.SugarTextBlock) return;
  window.SugarTextBlock = true;

  var MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function boolAttr(value) {
    return value === 'true';
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function ordinal(n) {
    var suffixes = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  }

  function getTimezoneCity() {
    try {
      var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (!timezone || timezone.indexOf('/') === -1) return '';
      return timezone.split('/').pop().replace(/_/g, ' ');
    } catch (e) {
      return '';
    }
  }

  function buildLocationText(data, type) {
    var city = data.city || '';
    var region = data.region || '';
    var country = data.country || '';

    if (type === 'region') return region;
    if (type === 'country') return country;
    if (type === 'city_region') return city && region ? city + ', ' + region : city || region;
    if (type === 'city_country') return city && country ? city + ', ' + country : city || country;
    return city;
  }

  function applyGeo(spans, geo) {
    spans.forEach(function (span) {
      var type = span.dataset.locationType || 'city';
      var fallback = span.dataset.locationFallback || 'your area';
      var text = buildLocationText(geo, type);
      span.textContent = text || fallback;
    });
  }

  function initLocation(block) {
    var spans = toArray(block.querySelectorAll('.text-block__location'));
    if (!spans.length) return;

    var needsInit = false;
    spans.forEach(function (span) {
      if (span.dataset.textLocationInitialized !== 'true') needsInit = true;
      span.dataset.textLocationInitialized = 'true';
    });
    if (!needsInit) return;

    var cacheKey = 'sugar_geo_v4';
    var cached = null;
    try { cached = sessionStorage.getItem(cacheKey); } catch (e) {}

    if (cached) {
      try {
        applyGeo(spans, JSON.parse(cached));
        return;
      } catch (e) {}
    }

    var firstSpan = spans[0];

    fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.success === false) throw new Error();
        return { city: data.city || '', region: data.region || '', country: data.country || '' };
      })
      .catch(function () {
        return {
          city: getTimezoneCity(),
          region: '',
          country: (firstSpan && (firstSpan.dataset.locationCountry || firstSpan.dataset.locationCountryCode)) || '',
        };
      })
      .then(function (geo) {
        try { sessionStorage.setItem(cacheKey, JSON.stringify(geo)); } catch (e) {}
        applyGeo(spans, geo);
      });
  }

  function initDates(block) {
    var spans = toArray(block.querySelectorAll('.text-block__date'));
    if (!spans.length) return;

    spans.forEach(function (span) {
      if (span.dataset.textDateInitialized === 'true') return;
      span.dataset.textDateInitialized = 'true';

      var offset = parseInt(span.dataset.dateOffset, 10) || 0;
      var direction = span.dataset.dateDirection === 'future' ? 1 : -1;
      var format = span.dataset.dateFormat || 'short';
      var date = new Date();
      date.setDate(date.getDate() + offset * direction);

      var d = date.getDate();
      var m = date.getMonth();
      var y = date.getFullYear();
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var text;

      switch (format) {
        case 'long':
          text = MONTH_FULL[m] + ' ' + d + ', ' + y; break;
        case 'day_name':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_SHORT[m] + ' ' + d; break;
        case 'day_name_long':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_FULL[m] + ' ' + d; break;
        case 'numeric':
          text = pad(m + 1) + '/' + pad(d) + '/' + y; break;
        case 'day_month':
          text = d + ' ' + MONTH_SHORT[m] + ' ' + y; break;
        case 'day_month_long':
          text = d + ' ' + MONTH_FULL[m] + ' ' + y; break;
        case 'month_day':
          text = MONTH_FULL[m] + ' ' + d; break;
        case 'long_ordinal':
          text = MONTH_FULL[m] + ' ' + ordinal(d) + ', ' + y; break;
        case 'day_dot_long_ordinal':
          text = DAY_NAMES[date.getDay()].slice(0, 3) + '. ' + MONTH_FULL[m] + ' ' + ordinal(d) + ', ' + y; break;
        case 'day_name_long_ordinal':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_FULL[m] + ' ' + ordinal(d); break;
        case 'day_month_long_ordinal':
          text = ordinal(d) + ' ' + MONTH_FULL[m] + ' ' + y; break;
        case 'month_day_ordinal':
          text = MONTH_FULL[m] + ' ' + ordinal(d); break;
        case 'month_short_day_ordinal':
          text = MONTH_SHORT[m] + ' ' + ordinal(d); break;
        case 'short_dot_ordinal':
          text = MONTH_SHORT[m] + (MONTH_SHORT[m] === MONTH_FULL[m] ? ' ' : '. ') + ordinal(d) + ' ' + y; break;
        default:
          text = MONTH_SHORT[m] + ' ' + d + ', ' + y;
      }

      span.textContent = text;
    });
  }

  function getParsedInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function resolveSectionTargetId(config) {
    var sectionId = (config.sectionId || '').replace(/^#/, '');
    if (sectionId) return sectionId;
    if (config.href && config.href.charAt(0) === '#') return config.href.slice(1);
    return '';
  }

  function scrollToSectionTarget(config) {
    var targetId = resolveSectionTargetId(config);
    if (!targetId) return;

    var target = document.getElementById(targetId);
    if (!target) return;

    var scrollOffset = getParsedInt(config.scrollOffset, 20);
    var headerHeight = getParsedInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0',
      0
    );
    var targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - scrollOffset;

    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  }

  function navigateToPage(config) {
    var href = config.href || '';
    if (!href || href === '#') return;

    if (config.newTab) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }

    window.location.href = href;
  }

  function initLinkActions(block) {
    var contentArea = block.querySelector('.sw-content') || block.querySelector('.text-block__content');
    if (!contentArea) return;

    var SELECTORS = { bold: 'strong', italic: 'em', underline: 'u, span[style*="underline"]', bold_italic: 'strong em, em strong' };
    // A text block nested inside this one (an accordion's panel) carries its own markers;
    // only the markers rendered directly under this block drive its words.
    var markers = toArray(block.querySelectorAll('[data-hl-link]')).filter(function (marker) {
      return marker.closest('[data-text-block]') === block;
    });
    var configs = markers.map(function (marker) {
      return {
        enabled: true,
        selector: SELECTORS[marker.dataset.target] || SELECTORS.bold,
        mode: marker.dataset.mode || 'page',
        href: marker.dataset.href || '',
        newTab: boolAttr(marker.dataset.newTab),
        sectionId: marker.dataset.sectionId || '',
        scrollOffset: marker.dataset.scrollOffset,
      };
    });


    configs.forEach(function (config) {
      if (!config.enabled) return;

      toArray(contentArea.querySelectorAll(config.selector)).forEach(function (trigger) {
        if (trigger.dataset.textLinkInitialized === 'true') return;
        if (trigger.closest('a')) return;

        trigger.dataset.textLinkInitialized = 'true';

        if (!trigger.hasAttribute('role')) trigger.setAttribute('role', 'link');
        if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
        if (!trigger.hasAttribute('aria-label')) {
          var label = (trigger.textContent || '').trim();
          if (label) trigger.setAttribute('aria-label', label);
        }

        function activate(event) {
          event.preventDefault();
          event.stopPropagation();

          if (config.mode === 'section') {
            scrollToSectionTarget(config);
            return;
          }

          navigateToPage(config);
        }

        trigger.addEventListener('click', activate);
        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            activate(event);
          }
        });
      });
    });
  }

  /*
   * [tier] token: each [data-tier-text] group holds one entry per bundle tier, keyed by the
   * tier's quantity (`2`) or by its position in the offer list (`#2`, for offers that share a
   * quantity, such as bundles sold as variants). The entry for the tier picked in Offer Cards /
   * Offer List shows, wherever the text sits on the page (a sticky bar follows the product
   * section). A tier with no entry keeps the one showing.
   */
  var TIER_GROUP = '[data-tier-text]';
  var SELECTED_TIER = '[data-sugar-offers] .offer.is-selected[data-quantity]';

  // 1-based position of an offer among the offers in its list.
  function offerPosition(offer) {
    var root = offer && offer.closest('[data-sugar-offers]');
    if (!root) return null;
    var offers = root.querySelectorAll('.offer[data-block-id]');
    for (var i = 0; i < offers.length; i++) {
      if (offers[i] === offer) return i + 1;
    }
    return null;
  }

  function tierOf(offer) {
    if (!offer) return null;
    var quantity = parseInt(offer.getAttribute('data-quantity'), 10);
    return { quantity: isNaN(quantity) ? null : quantity, position: offerPosition(offer) };
  }

  function selectedTierQuantity() {
    return tierOf(document.querySelector(SELECTED_TIER));
  }

  function tierMatches(key, tier) {
    if (!key) return false;
    if (key.charAt(0) === '#') return tier.position !== null && parseInt(key.slice(1), 10) === tier.position;
    return tier.quantity !== null && parseInt(key, 10) === tier.quantity;
  }

  function showTier(tier) {
    if (!tier) return;
    var groups = document.querySelectorAll(TIER_GROUP);
    if (!groups.length) return;

    // Read every group, then write only the entries whose state changes.
    var changes = [];
    for (var g = 0; g < groups.length; g++) {
      var entries = groups[g].children;
      var match = null;
      for (var i = 0; i < entries.length; i++) {
        if (tierMatches(entries[i].getAttribute('data-tier'), tier)) {
          match = entries[i];
          break;
        }
      }
      if (!match) continue;
      for (var j = 0; j < entries.length; j++) {
        if (!entries[j].hasAttribute('data-tier')) continue;
        var hide = entries[j] !== match;
        if (entries[j].hidden !== hide) changes.push([entries[j], hide]);
      }
    }
    for (var k = 0; k < changes.length; k++) changes[k][0].hidden = changes[k][1];
  }

  document.addEventListener('offers:quantity-changed', function (event) {
    var detail = event.detail || {};
    var offer = null;
    if (detail.blockId) {
      var offers = document.querySelectorAll('[data-sugar-offers] .offer[data-block-id]');
      for (var i = 0; i < offers.length; i++) {
        if (offers[i].getAttribute('data-block-id') === String(detail.blockId)) { offer = offers[i]; break; }
      }
    }
    var quantity = parseInt(detail.quantity, 10);
    showTier({ quantity: isNaN(quantity) ? null : quantity, position: offerPosition(offer) });
  });

  // Tevolio: follow the count picked in a Bundle Builder too (the docs promise it; only Offers fired it)
  document.addEventListener('bundle:changed', function (event) {
    var detail = event.detail || {};
    // Keyed by the exact count picked, so entries past the last tier (4, 5, 6...) still match
    var count = parseInt(detail.count, 10);
    if (!isNaN(count) && count > 0) showTier({ quantity: count, position: null });
  });

  function initBlock(block) {
    if (!block || block.dataset.textBlockInitialized === 'true') return;
    block.dataset.textBlockInitialized = 'true';
    initLinkActions(block);
    initLocation(block);
    initDates(block);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-text-block]')) {
      initBlock(scope);
    }

    toArray(scope.querySelectorAll('[data-text-block]')).forEach(initBlock);
    showTier(selectedTierQuantity());
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });
})();
